<template>
  <div class="date-filter">{{ $t('Дата') }}<div style="display: flex; flex-direction: row; gap: 15px">
      <DatePicker
          :placeholder="$t('С')"
          type="date"
          class="date-period"
          v-model:value="afterBorder"
          :lang="lang"
      />
      <DatePicker
          :placeholder="$t('По')"
          type="date"
          class="date-period"
          v-model:value="beforeBorder"
          :lang="lang"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import DatePicker from 'vue-datepicker-next';
import { formatDateTime } from "@/filters";
import Config from '@/config';

const { searchParams } = defineProps({
  searchParams: {
    type: Object,
    required: true,
  },
});

const afterBorder = ref(searchParams['after']);
const beforeBorder = ref(searchParams['after']);
const lang = Config.getUser().getLang();

watch(
  afterBorder,
  (newValue?: string) => {
    if (newValue) {
      searchParams['event.createdAt[after]'] = formatDateTime(newValue);

	  return;
	}
    delete searchParams['event.createdAt[after]'];
  },
);
watch(
  beforeBorder,
  (newValue?: string) => {
    if (newValue) {
      const beforeDate = new Date(newValue);
      beforeDate.setHours(23, 59, 59, 999);
      searchParams['event.createdAt[before]'] = formatDateTime(beforeDate.toISOString());

	  return;
	}
    delete searchParams['event.createdAt[before]'];
  },
);
</script>

<style scoped>
.date-filter {
  max-width: 435px;
}
</style>
